import { render, staticRenderFns } from "./AddonHorizontalView.vue?vue&type=template&id=ca30bdda&scoped=true"
import script from "./AddonHorizontalView.vue?vue&type=script&lang=js"
export * from "./AddonHorizontalView.vue?vue&type=script&lang=js"
import style0 from "./AddonHorizontalView.vue?vue&type=style&index=0&id=ca30bdda&prod&lang=scss&scoped=true"
import style1 from "./AddonHorizontalView.vue?vue&type=style&index=1&id=ca30bdda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca30bdda",
  null
  
)

export default component.exports